import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './main/App';
import * as serviceWorker from './serviceWorker'
import { ApolloProvider } from "react-apollo"
import ApolloClient from "apollo-boost"
import { InMemoryCache } from 'apollo-cache-inmemory'
import { endpoint, websocket } from './queries/endpoint'
import * as Sentry from '@sentry/browser'
import 'flexboxgrid'

// console.log(window.location.hostname)
if (window.location.hostname !== 'localhost') Sentry.init({ dsn: "https://f892bbf9809f4472b8775a170b82652f@sentry.io/1514598" })

// const appInsights = require("applicationinsights");
// appInsights.setup("da9b33d5-fb1a-48de-bc93-5e02f2b9914e")
//   .setAutoDependencyCorrelation(true)
//   .setAutoCollectRequests(true)
//   .setAutoCollectPerformance(true)
//   .setAutoCollectExceptions(true)
//   .setAutoCollectDependencies(true)
//   .setAutoCollectConsole(true)
//   .setUseDiskRetryCaching(true);
// appInsights.start();

// Check compatibility for the browser we're running this in
// if ("serviceWorker" in navigator) {
//   console.log("encontrou o serviceworker")
//   if (navigator.serviceWorker.controller) {
//     console.log("[PWA Builder] active service worker found, no need to register");
//   } else {
//     // Register the service worker
//     navigator.serviceWorker
//       .register("./serviceWorker.js", {
//         scope: "./"
//       })
//       .then(function (reg) {
//         console.log("[PWA Builder] Service worker has been registered for scope: " + reg.scope);
//       }).catch (err => console.log("PWA Build error: ", err))
//   }
// }

// console.log (!!sessionStorage.getItem("OITO"))
if (!!sessionStorage.getItem("OITO")) {
  // console.log("entrou no if")
  const token = JSON.parse(sessionStorage.getItem("OITO"))

  let webSocket = new WebSocket(websocket, 'graphql-subscriptions');

  const client = new ApolloClient({
    uri: endpoint,
    networkInterface: webSocket,
    cache: new InMemoryCache(),
    request: operation => {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token.token}`
        }
      });
    }
    // request: operation => {
    //   operation.setContext({
    //     headers: {
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${token.token}`
    //     }
    //   });
    // }
  })

  ReactDOM.render(
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
    , document.getElementById('root'));

} else {
  const client = new ApolloClient({
    uri: endpoint,
    cache: new InMemoryCache()
  })

  ReactDOM.render(
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
    , document.getElementById('root'));
}


serviceWorker.register();
